<div *adaptLoading="isLoading"
     class="chart-wrapper">
    <dx-polar-chart #careerValuationsDifferentialsChart
                    [hidden]="data.length === 0"
                    title="Differences between ideal and actual values"
                    [dataSource]="data"
                    [pathModified]="true"
                    [palette]="palette"
                    [series]="series"
                    (onPointClick)="onPointClick($event)"
                    (onInitialized)="onInitialized($event)">
        <!-- Options -->
        <dxo-polar-chart-size [height]="height"> </dxo-polar-chart-size>
        <dxo-polar-chart-argument-axis type="discrete">
            <dxo-polar-chart-minor-tick [visible]="false"></dxo-polar-chart-minor-tick>
            <dxo-polar-chart-tick [visible]="false"></dxo-polar-chart-tick>
            <dxo-polar-chart-minor-grid [visible]="false"></dxo-polar-chart-minor-grid>
            <dxo-polar-chart-grid [visible]="false"></dxo-polar-chart-grid>
            <dxo-polar-chart-label [visible]="false"></dxo-polar-chart-label>
        </dxo-polar-chart-argument-axis>
        <dxo-polar-chart-value-axis [maxValueMargin]="0.001"
                                    [tickInterval]="5">
            <dxo-polar-chart-minor-tick [visible]="false"></dxo-polar-chart-minor-tick>
            <dxo-polar-chart-tick [visible]="false"></dxo-polar-chart-tick>
            <dxo-polar-chart-minor-grid [visible]="false"></dxo-polar-chart-minor-grid>
            <dxo-polar-chart-label [visible]="true"></dxo-polar-chart-label>
        </dxo-polar-chart-value-axis>
        <dxo-polar-chart-common-series-settings type="scatter"
                                                argumentField="index"></dxo-polar-chart-common-series-settings>
        <dxo-polar-chart-tooltip [enabled]="true"
                                 [customizeTooltip]="customiseTooltip"></dxo-polar-chart-tooltip>
        <dxo-polar-chart-margin [bottom]="50"
                                [left]="100"></dxo-polar-chart-margin>
        <dxo-polar-chart-legend [visible]="isLegendVisible"></dxo-polar-chart-legend>
        <dxo-polar-chart-loading-indicator [enabled]="true"></dxo-polar-chart-loading-indicator>

        <!-- Series -->
        @for (category of categories; track category) {
            <dxi-polar-chart-series [name]="category.name"
                                    [valueField]="'category' + category.ordinal + 'value'"
                                    [tagField]="'category' + category.ordinal"></dxi-polar-chart-series>
        }
    </dx-polar-chart>

    @if (data.length === 0) {
        <div>
            <adapt-no-cultural-measurement label="Career Valuations"></adapt-no-cultural-measurement>
        </div>
    }
</div>
